module.exports = __webpack_public_path__ + "img/security-5-image.a9d93c67.jpg";